import { createAsyncThunk } from '@reduxjs/toolkit';
import companiesApi from '../../../../configs/apis/companies';

export const getCompanyUsers = createAsyncThunk(
  'companies/getCompanyUsers',
  // `filter` is optional. Written longhand because this repo's eslint parser cannot parse
  // `?.` — while this file failed to parse, the whole companies redux barrel failed to
  // resolve with it, so every importer reported a phantom "not found" error.
  async (payload, { rejectWithValue }) => companiesApi
    .getCompanyUsers({ ...payload,
      query: payload.filter ? payload.filter.searchValue : undefined,
      searchColumn: payload.filter ? payload.filter.searchColumn.id : undefined,
      status: payload.filter ? payload.filter.status.id : undefined,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const postCreditTransfer = createAsyncThunk(
  'companies/postCreditTransfer',
  async (payload, { rejectWithValue }) => companiesApi
    .postCreditTransfer(payload)
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const postReimbursedCredit = createAsyncThunk(
  'companies/postReimbursedCredit',
  async (payload, { rejectWithValue }) => companiesApi
    .postReimbursedCredit(payload)
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);
